<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar class="nav-bar" :title="$t('在线客服')">
        <template #left>
          <van-icon color="#fff" name="arrow-left" @click="$router.back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="servicelistItem">
      <div class="servicelistItemTop">
        <img class="servicelistItemImage" src="img/mine/kefu.png">
        <div class="servicelistItemText">
          {{ this.$store.getters.getBaseInfo.name !== undefined ? this.$store.getters.getBaseInfo.name : $t('蜜獾娱乐') }}
        </div>
        <div class="servicelistItemBtn" @click="toServicePage()">
          <div class="servicelistItemBtnText">
            {{ $t('联系') }}
          </div>
        </div>
      </div>
      <div class="servicelistItemBottom">
        <div class="servicelistItemInfoText">
          {{ $t('全天7 * 24小时竭诚为您服务') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    back() {
      return window.history.back();
    },
    isTelegramLink(url) {
      const telegramPattern = /^(https?:\/\/)?t\.me\/[a-zA-Z0-9_]+$/;
      return telegramPattern.test(url);
    },
    toServicePage() {
      const url = this.$store.getters.getBaseInfo.kefu
      if (this.isTelegramLink(url)) {
        window.open(url)
        return;
      }
      this.$router.push("ServicePage");
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.servicelistItem {
  display: flex;
  flex-direction: column;
  height: 200px;
  padding: 30px 30px;
  margin: 30px 20px;
  border-radius: 20px;
  justify-content: space-between;
  background: #fff;
}

.servicelistItem .servicelistItemTop {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 100px;
}

.servicelistItem .servicelistItemTop .servicelistItemImage {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.servicelistItem .servicelistItemTop .servicelistItemText {
  margin-left: 50px;
  font-size: 43px;
  font-weight: 700;
  color: #000;
  flex: 1;
}

.servicelistItem .servicelistItemTop .servicelistItemBtn {
  display: flex;
  width: 150px;
  height: 55px;
  border-radius: 30px;
  align-items: center;
  justify-content: center;
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
}

.servicelistItem .servicelistItemTop .servicelistItemBtn .servicelistItemBtnText {
  color: #fff;
  font-size: 25px;
}

.servicelistItem .servicelistItemBottom {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  background: #f2f2f5;
  border-radius: 10px;
  color: #979799;
}

.servicelistItem .servicelistItemBottom .servicelistItemInfoText {
  font-size: 30px;
}

// PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  // 导航栏PC端适配
  .nav-bar {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar {
    line-height: 57px !important;
  }

  ::v-deep .van-nav-bar__content {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar__title {
    font-size: 20px !important; /* 35px * 0.5733 ≈ 20px */
    max-width: 60% !important;
  }

  ::v-deep .van-nav-bar .van-icon {
    font-size: 26px !important; /* 45px * 0.5733 ≈ 26px */
  }

  // 客服卡片PC端适配
  .servicelistItem {
    height: 115px; /* 200px * 0.5733 ≈ 115px */
    padding: 17px 17px; /* 30px * 0.5733 ≈ 17px */
    margin: 17px 11px; /* 30px * 0.5733 ≈ 17px, 20px * 0.5733 ≈ 11px */
    border-radius: 11px; /* 20px * 0.5733 ≈ 11px */
  }

  .servicelistItem .servicelistItemTop {
    height: 57px; /* 100px * 0.5733 ≈ 57px */
  }

  .servicelistItem .servicelistItemTop .servicelistItemImage {
    width: 46px; /* 80px * 0.5733 ≈ 46px */
    height: 46px; /* 80px * 0.5733 ≈ 46px */
  }

  .servicelistItem .servicelistItemTop .servicelistItemText {
    margin-left: 29px; /* 50px * 0.5733 ≈ 29px */
    font-size: 25px; /* 43px * 0.5733 ≈ 25px */
  }

  .servicelistItem .servicelistItemTop .servicelistItemBtn {
    width: 86px; /* 150px * 0.5733 ≈ 86px */
    height: 32px; /* 55px * 0.5733 ≈ 32px */
    border-radius: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  .servicelistItem .servicelistItemTop .servicelistItemBtn .servicelistItemBtnText {
    font-size: 14px; /* 25px * 0.5733 ≈ 14px */
  }

  .servicelistItem .servicelistItemBottom {
    height: 29px; /* 50px * 0.5733 ≈ 29px */
    border-radius: 6px; /* 10px * 0.5733 ≈ 6px */
  }

  .servicelistItem .servicelistItemBottom .servicelistItemInfoText {
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
  }
}
</style>
